import React from "react";
import IconRemove from "../../assets/icons/remove_icon.svg";
import useCartStore from "../../stores/cartStore";

const HeaderCartItem = ({ item }) => {
  const removeFromCart = useCartStore((state) => state.removeFromCart);
  const increaseQuantity = useCartStore((state) => state.increaseQuantity);
  const decreaseQuantity = useCartStore((state) => state.decreaseQuantity);

  return (
    <div className="cart_item">
      <div className="top_item">
        <figure>
          <img src={item.thumbnail} alt={item.title} />
        </figure>
        <div className="txt">
          <h4>{item.title}</h4>
          <h5>
            <span>￦</span>
            {item.price.toLocaleString()}
          </h5>
        </div>
      </div>
      <ul className="bot_items">
        <li className="quantity_controls">
          <button onClick={() => decreaseQuantity(item.code)}>
            <i className="fa-solid fa-minus"></i>
          </button>
          <p className="count">{item.quantity}</p>
          <button onClick={() => increaseQuantity(item.code)}>
            <i className="fa-solid fa-plus"></i>
          </button>
        </li>
        <li className="removeBtn" onClick={() => removeFromCart(item.code)}>
          <div className="remove_wrap">
            <img src={IconRemove} alt="removeIcon" />
            <p>REMOVE</p>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default React.memo(HeaderCartItem);
